import { render, staticRenderFns } from "./PurchaseRequisition.vue?vue&type=template&id=80cd610a&scoped=true&"
import script from "./PurchaseRequisition.vue?vue&type=script&lang=ts&"
export * from "./PurchaseRequisition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cd610a",
  null
  
)

export default component.exports